<template>
    <a :href="slide.url" class="block  bg-hh-grey-50 cursor-pointer hover:opacity-90">
        <div class="h-48">

            <picture :title="slide.place" class="xl:h-full overflow-hidden ">
                <source :srcset="slide.image.replace('.jpg', '.webp')" type="image/webp">
                <source :srcset="slide.image" type="image/jpg">
                <img
                    width="100%"
                    height="100%"
                    class="w-full h-full object-cover object-cover"
                    :src="slide.image"
                    :alt="slide.place"
                    loading="lazy"
                    draggable="false"
                />
            </picture>

        </div>
        <div class="flex flex-col justify-between h-48 p-4">
            <div>
                <div class="text-hh-grey-900 font-medium" v-html="slide.place"></div>
                <div class="text-hh-grey-700 text-sm" v-html="slide.people + ' | ' + slide.bedrooms"></div>
            </div>
            <div class="text-right text-base text-hh-grey-700">
                <div class="" v-html="slide.price.los"></div>
                <div class="text-hh-grey-900 text-2xl font-semibold" v-html="slide.price.current"></div>
                <div class="font-normal" v-html="slide.price.basedOn"></div>
            </div>
        </div>
    </a>
</template>

<script>
export default {

    name: 'LastViewed',

    props: ['slide'],

};
</script>
